<div class="obg-ksa-limits-alert-header">
	<h2 class="obg-ksa-limits-alert-header-text" *ngIf="content?.title" [innerHtml]="content?.title | translate"></h2>
	<div class="obg-ksa-limits-alert-header-ico" *ngIf="content?.icon">
		<span [ngClass]="'ico ' + content?.icon"></span>
	</div>
</div>
<div class="obg-ksa-limits-alert-body">
	<div
		class="obg-ksa-limits-alert-body-message"
		*ngIf="content?.message"
		[innerHtml]="content?.message | translate"
	></div>
	<div class="obg-ksa-limits-alert-body-amount-title" *ngIf="content?.amountTitle">
		{{ content?.amountTitle | translate }}
	</div>
	<div class="obg-ksa-limits-alert-body-amount-value" *ngIf="content?.amountValue">
		<span *ngIf="content?.limitType">/{{ content?.limitType | translate }}</span>
		{{ content?.amountValue | translate }}
	</div>
</div>
<hr />
<div class="obg-ksa-limits-alert-footer" *ngIf="content?.footer" [innerHtml]="content?.footer | translate"></div>
